import React, { useState } from "react";
import axios from "axios";
import { MarketingLayout } from "../../components/enterprise2/MarketingLayout";
import { TwoCol } from "../../components/enterprise2/TwoCol";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const empty = { name: "", work_email: "", organisation: "", message: "" };

export default function Contact() {
  const [form, setForm] = useState(empty);
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [banner, setBanner] = useState(null);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Please share your name.";
    if (!form.work_email.trim() || !EMAIL_RE.test(form.work_email.trim())) e.work_email = "Please check the email address.";
    if (!form.organisation.trim()) e.organisation = "Please share your organisation.";
    if (!form.message.trim() || form.message.trim().length < 8) e.message = "A short note helps us route the reply.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = async (evt) => {
    evt.preventDefault();
    if (!validate()) return;
    setBusy(true);
    setBanner(null);
    try {
      await axios.post(`${API}/marketing/contact`, form);
      setSent(true);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Could not send just now. Please try again in a moment.";
      setBanner(String(msg));
    } finally {
      setBusy(false);
    }
  };

  const bind = (k) => ({
    value: form[k],
    onChange: (e) => setForm((f) => ({ ...f, [k]: e.target.value })),
  });

  return (
    <MarketingLayout
      active="contact"
      title="Contact us. Crowther."
      description="Reach out and we will respond within one business day."
    >
      <TwoCol
        as="h1"
        id="e2-contact"
        label="Contact"
        title="Let us talk."
        lede="Tell us a little about your firm and we will come back to you within one business day."
      >
        {sent ? (
          <div className="e2-form" data-testid="e2-contact-success">
            <p className="e2-serif-lead">Received.</p>
            <p className="e2-body">We will respond within one business day.</p>
          </div>
        ) : (
          <form className="e2-form" onSubmit={submit} data-testid="e2-contact-form">
            <div className="field">
              <label htmlFor="e2-name">Name</label>
              <input id="e2-name" data-testid="e2-contact-name" {...bind("name")} />
              {errors.name && <div className="err">{errors.name}</div>}
            </div>
            <div className="field">
              <label htmlFor="e2-email">Work email</label>
              <input id="e2-email" data-testid="e2-contact-email" {...bind("work_email")} />
              {errors.work_email && <div className="err">{errors.work_email}</div>}
            </div>
            <div className="field">
              <label htmlFor="e2-org">Organisation</label>
              <input id="e2-org" data-testid="e2-contact-org" {...bind("organisation")} />
              {errors.organisation && <div className="err">{errors.organisation}</div>}
            </div>
            <div className="field">
              <label htmlFor="e2-msg">Message</label>
              <textarea id="e2-msg" data-testid="e2-contact-message" {...bind("message")} />
              {errors.message && <div className="err">{errors.message}</div>}
            </div>
            {banner && <div className="err" data-testid="e2-contact-banner">{banner}</div>}
            <div>
              <button
                type="submit"
                className="e2-btn e2-btn-primary"
                disabled={busy}
                data-testid="e2-contact-submit"
              >
                {busy ? "Sending\u2026" : "Send message"}
              </button>
            </div>
          </form>
        )}
        <p className="e2-body" style={{ marginTop: 40 }}>
          Prefer the direct route? <a href="mailto:contact@crowtherlabs.com" style={{ borderBottom: "1px solid var(--forest)" }}>contact@crowtherlabs.com</a>.
        </p>
      </TwoCol>
    </MarketingLayout>
  );
}
